'use client';

import React, { useState } from 'react';
import { useRouter } from 'next/navigation';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';

const Interestform = () => {
  const [step, setStep] = useState(1);
  const [show, setShow] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState('');
  const [countryCodeInput, setCountryCodeInput] = useState(''); // State for country code input
  const [loading, setLoading] = useState(false);
  const router = useRouter();

  const initialFormData = {
    name: '',
    email: '',
    mobile: '',
    time: '',
    agent_name: '',
    is_referral: '',
    prefer_language: '',
    country: '',
    passport_number: '',
  };
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});

  const generateTicketNumber = () => {
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const digits = '0123456789';

    let ticketNumber = '';

    for (let i = 0; i < 6; i++) {
      if (i % 2 === 0) {
        ticketNumber += letters.charAt(
          Math.floor(Math.random() * letters.length)
        );
      } else {
        ticketNumber += digits.charAt(
          Math.floor(Math.random() * digits.length)
        );
      }
    }

    return ticketNumber;
  };

  const API_URL = process.env.NEXT_PUBLIC_API_URL;
  const API_TOKEN = process.env.NEXT_PUBLIC_API_TOKEN;

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validateMobile = (mobile) => {
    // const mobilePattern = /^(?:\+971|971|0)\d{9}$/; // Validates UAE number format
    const isNumeric = /^\d+$/.test(mobile); // Check if the input is numeric
    const validLength = mobile.length >= 8 && mobile.length <= 15; // Adjust min and max length as needed
    return isNumeric && validLength;
  };

  const countryCodes = {
    Afghanistan: '+93',
    Albania: '+355',
    Algeria: '+213',
    Andorra: '+376',
    Angola: '+244',
    'Antigua and Barbuda': '+1-268',
    Argentina: '+54',
    Armenia: '+374',
    Australia: '+61',
    Austria: '+43',
    Azerbaijan: '+994',
    Bahamas: '+1-242',
    Bahrain: '+973',
    Bangladesh: '+880',
    Barbados: '+1-246',
    Belarus: '+375',
    Belgium: '+32',
    Belize: '+501',
    Benin: '+229',
    Bhutan: '+975',
    Bolivia: '+591',
    'Bosnia and Herzegovina': '+387',
    Botswana: '+267',
    Brazil: '+55',
    Brunei: '+673',
    Bulgaria: '+359',
    'Burkina Faso': '+226',
    Burundi: '+257',
    'Cabo Verde': '+238',
    Cambodia: '+855',
    Cameroon: '+237',
    Canada: '+1',
    'Central African Republic': '+236',
    Chad: '+235',
    Chile: '+56',
    China: '+86',
    Colombia: '+57',
    Comoros: '+269',
    'Congo, Democratic Republic of the': '+243',
    'Congo, Republic of the': '+242',
    'Costa Rica': '+506',
    Croatia: '+385',
    Cuba: '+53',
    Cyprus: '+357',
    'Czech Republic': '+420',
    Denmark: '+45',
    Djibouti: '+253',
    Dominica: '+1-767',
    'Dominican Republic': '+1-809',
    Ecuador: '+593',
    Egypt: '+20',
    'El Salvador': '+503',
    'Equatorial Guinea': '+240',
    Eritrea: '+291',
    Estonia: '+372',
    Eswatini: '+268',
    Ethiopia: '+251',
    Fiji: '+679',
    Finland: '+358',
    France: '+33',
    Gabon: '+241',
    Gambia: '+220',
    Georgia: '+995',
    Germany: '+49',
    Ghana: '+233',
    Greece: '+30',
    Grenada: '+1-473',
    Guatemala: '+502',
    Guinea: '+224',
    'Guinea-Bissau': '+245',
    Guyana: '+592',
    Haiti: '+509',
    Honduras: '+504',
    Hungary: '+36',
    Iceland: '+354',
    India: '+91',
    Indonesia: '+62',
    Iran: '+98',
    Iraq: '+964',
    Ireland: '+353',
    Israel: '+972',
    Italy: '+39',
    Jamaica: '+1-876',
    Japan: '+81',
    Jordan: '+962',
    Kazakhstan: '+7',
    Kenya: '+254',
    Kiribati: '+686',
    'Korea, North': '+850',
    'Korea, South': '+82',
    Kuwait: '+965',
    Kyrgyzstan: '+996',
    Laos: '+856',
    Latvia: '+371',
    Lebanon: '+961',
    Lesotho: '+266',
    Liberia: '+231',
    Libya: '+218',
    Liechtenstein: '+423',
    Lithuania: '+370',
    Luxembourg: '+352',
    Madagascar: '+261',
    Malawi: '+265',
    Malaysia: '+60',
    Maldives: '+960',
    Mali: '+223',
    Malta: '+356',
    'Marshall Islands': '+692',
    Mauritania: '+222',
    Mauritius: '+230',
    Mexico: '+52',
    Micronesia: '+691',
    Moldova: '+373',
    Monaco: '+377',
    Mongolia: '+976',
    Montenegro: '+382',
    Morocco: '+212',
    Mozambique: '+258',
    Myanmar: '+95',
    Namibia: '+264',
    Nauru: '+674',
    Nepal: '+977',
    Netherlands: '+31',
    'New Zealand': '+64',
    Nicaragua: '+505',
    Niger: '+227',
    Nigeria: '+234',
    'North Macedonia': '+389',
    Norway: '+47',
    Oman: '+968',
    Pakistan: '+92',
    Palau: '+680',
    Panama: '+507',
    'Papua New Guinea': '+675',
    Paraguay: '+595',
    Peru: '+51',
    Philippines: '+63',
    Poland: '+48',
    Portugal: '+351',
    Qatar: '+974',
    Romania: '+40',
    Russia: '+7',
    Rwanda: '+250',
    'Saint Kitts and Nevis': '+1-869',
    'Saint Lucia': '+1-758',
    'Saint Vincent and the Grenadines': '+1-784',
    Samoa: '+685',
    'San Marino': '+378',
    'Sao Tome and Principe': '+239',
    'Saudi Arabia': '+966',
    Senegal: '+221',
    Serbia: '+381',
    Seychelles: '+248',
    'Sierra Leone': '+232',
    Singapore: '+65',
    Slovakia: '+421',
    Slovenia: '+386',
    'Solomon Islands': '+677',
    Somalia: '+252',
    'South Africa': '+27',
    'South Korea': '+82',
    'South Sudan': '+211',
    Spain: '+34',
    'Sri Lanka': '+94',
    Sudan: '+249',
    Suriname: '+597',
    Sweden: '+46',
    Switzerland: '+41',
    Syria: '+963',
    Taiwan: '+886',
    Tajikistan: '+992',
    Tanzania: '+255',
    Thailand: '+66',
    'Timor-Leste': '+670',
    Togo: '+228',
    Tonga: '+676',
    'Trinidad and Tobago': '+1-868',
    Tunisia: '+216',
    Turkey: '+90',
    Turkmenistan: '+993',
    Tuvalu: '+688',
    Uganda: '+256',
    Ukraine: '+380',
    'United Arab Emirates': '+971',
    'United Kingdom': '+44',
    'United States': '+1',
    Uruguay: '+598',
    Uzbekistan: '+998',
    Vanuatu: '+678',
    'Vatican City': '+379',
    Venezuela: '+58',
    Vietnam: '+84',
    Yemen: '+967',
    Zambia: '+260',
    Zimbabwe: '+263',
  };

  const handleCountryChange = (event) => {
    const selected = event.target.value;
    setSelectedCountry(selected);
    setCountryCodeInput(countryCodes[selected] || ''); // Update country code input dynamically
    setFormData({ ...formData, country: selected });
  };

  const handleCountryCodeChange = (e) => {
    const value = e.target.value.replace(/[^+\d]/g, ''); // Allow only '+' and digits
    setCountryCodeInput(value); // Update country code input value
  };

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
    setFormData({ ...formData, mobile: value });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const numericValue = name === 'mobile' ? value.replace(/\D/g, '') : value;

    setFormData((prev) => ({ ...prev, [name]: numericValue }));

    // Validate input fields and set errors
    if (name === 'mobile') {
      if (!validateMobile(numericValue)) {
        setErrors((prev) => ({
          ...prev,
          mobile: 'Please enter a valid mobile number (8-15 digits).',
        }));
      } else {
        setErrors((prev) => {
          const { mobile, ...rest } = prev; // Remove mobile error if valid
          return rest;
        });
      }
    } else {
      setErrors((prev) => ({ ...prev, [name]: '' })); // Clear error on valid input
    }
  };

  const handleNext = () => {
    const currentErrors = {};
    if (!formData.name.trim()) currentErrors.name = 'Name is required.';
    if (!formData.email) currentErrors.email = 'Email is required.';
    if (!formData.mobile) currentErrors.mobile = 'Mobile is required.';
    if (formData?.email && !validateEmail(formData?.email))
      currentErrors.email = 'Invalid email address.';
    if (formData.mobile && !validateMobile(formData.mobile, formData.country))
      currentErrors.mobile = 'Invalid mobile number.';
    if (!formData.country) currentErrors.country = 'Country is required.';
    if (Object.keys(currentErrors).length > 0) {
      setErrors(currentErrors);
    } else {
      setStep(2);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    const currentErrors = {};
    if (!formData.time) currentErrors.time = 'Timeslot is required.';
    if (!formData.is_referral)
      currentErrors.is_referral = 'Referral By is required.';
    if (formData.is_referral === 'yes' && !formData.agent_name.trim()) {
      currentErrors.agent_name = 'Agent name is required for referrals.';
    }
    if (Object.keys(currentErrors).length > 0) {
      setErrors(currentErrors);
      setLoading(false);
      return;
    }

    const ticket_number = generateTicketNumber();

    // Retrieve the country code from the input field
    const countryCode = countryCodeInput || '';

    // const countryCode = selectedCountry ? countryCodes[selectedCountry] : '';
    formData.mobile = `${countryCode}-${formData?.mobile}`;

    try {
      const formDataWithTicket = {
        ...formData,
        ticket_number,
      };

      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${API_TOKEN}`,
        },
        body: JSON.stringify(formDataWithTicket),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error('API request failed');
      }

      let data;

      try {
        data = await response.json();
      } catch (e) {
        console.error('Failed to parse JSON:', e);
      }

      if (response.ok) {
        try {
          await fetch('/api/openhouse/', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },

            body: JSON.stringify({
              name: formData.name,
              email: formData.email,
              message: `
              <div style="
                  position: relative;
                  max-width: 500px;
                  margin: 0 auto;
                  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
                              url('https://images.x-space.ae/assets/images/damac_island_pictures/DAMAC-ISLANDS-Digital-Brochure-EN_Page_10.webp') no-repeat center center;
                  background-size: cover;
                  padding: 20px;
                  color: white;
                  border-radius: 8px;
                  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                  font-family: Arial, sans-serif;">

                  <p style="font-size: 20px; color: white; text-align: center; margin-bottom: 10px;">Damac Real Estate</p>
                  <p style="font-weight: bold; font-size: 40px; color: #0891b2; text-align: center; margin-top: 10px;">YEAR-END BONANZA <br/>OPEN HOUSE</p>

                  <h2 style="text-align: center; color: white; font-weight: normal; font-size: 19px; letter-spacing: 4px; margin-bottom: 3rem;">THANK YOU FOR REGISTERING <br/> YOUR INTEREST</h2>

                  <p style="text-align: center; font-size: 16px; color: white; line-height: 1.6; margin: 10px 0;">Dear <strong>${formData.name}</strong></p>
                  <p style="text-align: center; font-size: 20px; color: white; line-height: 1.6; margin: 10px 0;">Ticket No</p>
                  <p style="border-radius: 10px; text-align: center; font-size: 24px; background-color: #0891b2; color: black; line-height: 1.6; margin: auto; padding: 15px; width: fit-content;">${ticket_number}</p>
                  <p style="font-size: 18px; color: white; line-height: 1.6; margin-top: 20px; margin-bottom: 6px; text-align: center;">Confirmation Date & Time</p>
                  <p style="font-size: 23px; color: white; line-height: 1.6; margin-top: 0px; text-align: center;">28 Dec 2024, ${formData.time}</p>

                  <div style="padding: 15px; border-radius: 5px; text-align: center;">
                      <p style="font-size: 14px; color: white; margin: 10px 0;">XSPACE REAL ESTATE</p>
                      <p style="font-size: 14px; color: white; margin: 10px 0;">Thank you for your booking! We look forward to serving you.</p>
                      <p style="font-size: 14px; color: white; margin: 10px 0;">
                          If you have any questions, feel free to <a href="https://x-space.ae/contact-us" style="color: #2980b9; text-decoration: none;">contact us</a>.
                      </p>
                  </div>
                  <footer style="font-size: 12px; color: white; text-align: center;">
                      <p style="margin: 5px 0; text-align: center;">&copy; 2024 X-Space Real Estate. All Rights Reserved.</p>
                      <p style="margin: 5px 0; text-align: center;">
                          <a href="https://x-space.ae/cookies-policy" style="color: white; text-decoration: none;">Privacy Policy</a> |
                          <a href="https://x-space.ae/cookies-policy" style="color: white; text-decoration: none;">Terms of Service</a>
                      </p>
                  </footer>
              </div>
            `,
            }),
          });
        } catch (e) {
          console.error(e);
        }
        router.push('/damac-openhouse-interest/thank-you');
        setFormData(initialFormData);
      } else {
        console.error('Submission error:', data);
        alert('Form submission failed.');
      }

      // Submission logic here...
      setFormData(initialFormData);
      setStep(1);
    } catch (error) {
      console.error('Error during form submission:', error);
      alert('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete='off'
      className='bg-opacity-20 bg-white flex flex-col gap-4 items-center justify-center w-fit p-10 rounded-3xl z-10'
    >
      <h2 className='text-4xl font-extrabold text-center'>
        Register Your Interest
      </h2>
      <p className='text-lg text-center text-white/80'>
        Fill out the form below to explore luxury living opportunities.
      </p>
      {step === 1 && (
        <>
          {/* Name Field */}
          <div className='flex flex-col gap-1 w-full'>
            <label className='text-white' htmlFor='name'>
              Name <span className='text-red-500'>*</span>
            </label>
            <input
              required
              type='text'
              name='name'
              placeholder='Enter your name'
              value={formData.name}
              onChange={handleChange}
              minLength={2} // Minimum length for name
              maxLength={50} // Maximum length for name
              className={`rounded-lg bg-opacity-35 bg-black placeholder:text-white text-white border ${
                errors.name ? 'border-red-500' : 'border-primarycolor'
              } focus:outline-none focus:ring-2 ${
                errors.name ? 'focus:ring-red-500' : 'focus:ring-primarycolor'
              } px-4 py-2`}
            />
            {errors.name && (
              <p className='font-bold text-red-400 text-[1.2rem] mt-1'>
                {errors.name}
              </p>
            )}
          </div>

          {/* Email Field */}
          <div className='flex flex-col gap-1 w-full'>
            <label className='text-white' htmlFor='email'>
              Email <span className='text-red-500'>*</span>
            </label>
            <input
              required
              type='email'
              name='email'
              placeholder='Enter your valid email'
              value={formData.email}
              onChange={handleChange}
              minLength={5} // Minimum length for email
              maxLength={100} // Maximum length for email
              className={`rounded-lg bg-opacity-35 bg-black placeholder:text-white text-white border ${
                errors.email ? 'border-red-500' : 'border-primarycolor'
              } focus:outline-none focus:ring-2 ${
                errors.email ? 'focus:ring-red-500' : 'focus:ring-primarycolor'
              } px-4 py-2`}
            />
            {errors.email && (
              <p className='font-bold text-red-400 text-[1.2rem] mt-1'>
                {errors.email}
              </p>
            )}
          </div>

          <div className='flex flex-col gap-1 w-full'>
            <label className='text-white' htmlFor='country'>
              Country / Nationality <span className='text-red-500'>*</span>
            </label>
            <select
              required
              name='country'
              value={formData.country}
              onChange={handleCountryChange}
              className={`rounded-lg bg-opacity-35 bg-black placeholder:text-white text-white border ${
                errors.country ? 'border-red-500' : 'border-primarycolor'
              } focus:outline-none focus:ring-2 ${
                errors.country
                  ? 'focus:ring-red-500'
                  : 'focus:ring-primarycolor'
              } px-4 py-2`}
            >
              <option value=''>Select a country</option>
              {Object.keys(countryCodes).map((country) => (
                <option key={country} value={country}>
                  {country}
                </option>
              ))}
            </select>

            {errors.country && (
              <p className='font-bold text-red-400 text-[1.2rem] mt-1'>
                {errors.country}
              </p>
            )}
          </div>

          <div className='flex flex-col gap-1 w-full'>
            <label className='text-white' htmlFor='mobile'>
              Mobile <span className='text-red-500'>*</span>
            </label>
            <div className='flex items-center'>
              <input
                type='text'
                name='countryCode'
                placeholder='+'
                value={countryCodeInput}
                onChange={handleCountryCodeChange}
                minLength={2}
                maxLength={4}
                className='text-white bg-black px-4 py-2 rounded-lg w-20 focus:outline-none focus:ring-2 focus:ring-primarycolor border border-primarycolor'
              />
              <input
                required
                type='tel'
                name='mobile'
                placeholder='Enter your mobile number'
                value={formData.mobile}
                onChange={handleMobileChange}
                className={`rounded-lg bg-opacity-35 bg-black placeholder:text-white text-white border ${
                  errors.mobile ? 'border-red-500' : 'border-primarycolor'
                } focus:outline-none focus:ring-2 ${
                  errors.mobile
                    ? 'focus:ring-red-500'
                    : 'focus:ring-primarycolor'
                } px-6 py-2 w-full`}
                minLength={8} // Minimum length for mobile number
                maxLength={15} // Maximum length for mobile number
              />
            </div>
            {errors.mobile && (
              <p className='font-bold text-red-400 text-[1.2rem] mt-1'>
                {errors.mobile}
              </p>
            )}
          </div>

          <button
            type='button'
            onClick={handleNext}
            className='bg-primarycolor border border-primarycolor text-white px-6 py-2 rounded-md mt-4 hover:bg-opacity-80'
          >
            Next
          </button>
        </>
      )}

      {step === 2 && (
        <>
          {/* Timeslot Field */}
          <div className='flex flex-col gap-1 w-full'>
            <label className='text-white' htmlFor='time-slot'>
              Timeslot <span className='text-red-500'>*</span>
            </label>
            <select
              required
              name='time'
              value={formData.time}
              onChange={handleChange}
              className={`rounded-lg bg-opacity-35 bg-black placeholder:text-white text-white border ${
                errors.time ? 'border-red-500' : 'border-primarycolor'
              } focus:outline-none focus:ring-2 ${
                errors.time ? 'focus:ring-red-500' : 'focus:ring-primarycolor'
              } px-4 py-2`}
            >
              <option value=''>Select a timeslot</option>
              <option value='10:00 - 11:00'>10:00 - 11:00</option>
              <option value='11:00 - 12:00'>11:00 - 12:00</option>
              <option value='12:00 - 13:00'>12:00 - 13:00</option>
              <option value='13:00 - 14:00'>13:00 - 14:00</option>
              <option value='14:00 - 15:00'>14:00 - 15:00</option>
              <option value='15:00 - 16:00'>15:00 - 16:00</option>
              <option value='16:00 - 17:00'>16:00 - 17:00</option>
              <option value='17:00 - 18:00'>17:00 - 18:00</option>
            </select>
            {errors.time && (
              <p className='font-bold text-red-400 text-[1.2rem] mt-1'>
                {errors.time}
              </p>
            )}
          </div>

          <div className='flex flex-col gap-1 w-full'>
            <label className='text-white' htmlFor='name'>
              Prefer Language
            </label>
            <input
              required
              type='text'
              name='prefer_language'
              value={formData.prefer_language}
              onChange={handleChange}
              minLength={5}
              maxLength={50}
              className={`rounded-lg bg-opacity-35 bg-black placeholder:text-white text-white border ${
                errors.passport_number
                  ? 'border-red-500'
                  : 'border-primarycolor'
              } focus:outline-none focus:ring-2 ${
                errors.passport_number
                  ? 'focus:ring-red-500'
                  : 'focus:ring-primarycolor'
              } px-4 py-2`}
            />
            {errors.passport_number && (
              <p className='font-bold text-red-400 text-[1.2rem] mt-1'>
                {errors.passport_number}
              </p>
            )}
          </div>

          <div className='flex flex-col gap-1 w-full'>
            <label className='text-white' htmlFor='passport-number'>
              Passport Number
            </label>
            <input
              type='text'
              name='passport_number'
              placeholder='Enter your valid passport number'
              value={formData.passport_number}
              onChange={handleChange}
              minLength={5} // Minimum length for passport number
              maxLength={15} // Maximum length for passport number
              className={`rounded-lg bg-opacity-35 bg-black placeholder:text-white text-white border ${
                errors.passport_number
                  ? 'border-red-500'
                  : 'border-primarycolor'
              } focus:outline-none focus:ring-2 ${
                errors.passport_number
                  ? 'focus:ring-red-500'
                  : 'focus:ring-primarycolor'
              } px-4 py-2`}
            />
            {errors.passport_number && (
              <p className='font-bold text-red-400 text-[1.2rem] mt-1'>
                {errors.passport_number}
              </p>
            )}
          </div>

          {/* Referral Agent */}
          <div className='flex flex-col gap-1 w-full'>
            <label className='text-white' htmlFor='referral-agents'>
              Referral By Agent <span className='text-red-500'>*</span>
            </label>
            <div className='flex ml-4 items-center gap-6'>
              <label className='flex items-center gap-2 text-white cursor-pointer'>
                <input
                  type='radio'
                  name='is_referral'
                  value='yes'
                  onChange={handleChange}
                  className='hidden peer'
                  onClick={() => {
                    setShow(true);
                  }}
                />
                <div className='w-5 h-5 border-4 border-primarycolor rounded-full flex items-center justify-center peer-checked:bg-white'>
                  <div className='w-2.5 h-2.5 bg-white rounded-full hidden peer-checked:block'></div>
                </div>
                Yes
              </label>

              <label className='flex items-center gap-2 text-white cursor-pointer'>
                <input
                  type='radio'
                  name='is_referral'
                  value='no'
                  onChange={handleChange}
                  className='hidden peer'
                  onClick={() => {
                    setShow(false);
                  }}
                />
                <div className='w-5 h-5 border-4 border-primarycolor rounded-full flex items-center justify-center peer-checked:bg-white'>
                  <div className='w-2.5 h-2.5 bg-white rounded-full hidden peer-checked:block'></div>
                </div>
                No
              </label>
            </div>
            {errors.is_referral && (
              <p className='font-bold text-red-400 text-[1.2rem] mt-1'>
                {errors.is_referral}
              </p>
            )}
          </div>

          {/* Show agent name if referral */}
          {show && (
            <div className='flex flex-col gap-1 w-full'>
              <label className='text-white' htmlFor='agent_name'>
                Agent Name <span className='text-red-500'>*</span>
              </label>
              <input
                required={formData.is_referral === 'yes'}
                type='text'
                name='agent_name'
                onChange={handleChange}
                value={formData.agent_name}
                minLength={1}
                maxLength={50}
                className={`rounded-lg bg-opacity-35 bg-black placeholder:text-white text-white border ${
                  errors.agent_name ? 'border-red-500' : 'border-primarycolor'
                } focus:outline-none focus:ring-2 ${
                  errors.agent_name
                    ? 'focus:ring-red-500'
                    : 'focus:ring-primarycolor'
                } px-4 py-2`}
              />
              {errors.agent_name && (
                <p className='font-bold text-red-400 text-[1.2rem] mt-1'>
                  {errors.agent_name}
                </p>
              )}
            </div>
          )}

          <div className='flex flex-row justify-between w-full'>
            <button
              type='button'
              onClick={() => setStep(1)}
              disabled={loading} // Disable button when loading is true
              className={`bg-gray-500 text-white px-6 py-2 rounded-md mt-4 hover:bg-opacity-80 ${
                loading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              Previous
            </button>

            <button
              type='submit'
              className='bg-primarycolor border border-primarycolor text-white px-6 py-2 rounded-md mt-4 hover:bg-opacity-80'
            >
              {loading ? (
                <Stack spacing={2} direction='row' alignItems='center'>
                  <CircularProgress color='inherit' size='25px' />
                </Stack>
              ) : (
                'Submit'
              )}
            </button>
          </div>
        </>
      )}
    </form>
  );
};

export default Interestform;
